import { snakeToCamel } from './String';

export const camelizeKeys = (obj: any): any => {
  if (obj === null) {
    return null;
  }

  if (typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(camelizeKeys);
  }

  const entries = Object.entries(obj);
  const camelizedEntries = entries.map(
    ([key, value]) => [snakeToCamel(key), camelizeKeys(value)] as const
  );

  return Object.fromEntries(camelizedEntries);
};

/**
 * Convenience method for one line conditional object property assignment
 *
 * @example Usage:
 *  interface Foo {
 *    prop1?: number;
 *    prop2?: MyEnum;
 *    prop3: string;
 *  }
 *  const someCondition = true;
 *  const otherCondition = false;
 *
 *  const foo = {
 *    prop3: 'bar',
 *    ...conditionalAssignment(someCondition, { prop1: 1 }),
 *    ...conditionalAssignment(otherCondition, { prop2: MyEnum.Value1 }),
 *  };
 *
 *  // foo = { prop1: 1, prop3: 'bar' }
 */
export const conditionalAssignment = (
  condition: boolean,
  value: Record<string, unknown>
): Record<string, unknown> | undefined => (condition ? value : undefined);

export const buildComposedKey = (record: { id: string; type: any }): string =>
  `${record.id}-${record.type}`;
